var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19003 2.51953L11.4623 7.49383V7.49269V2.53101H12.6833V7.51609L18.9836 2.51953V8.19097H21.5704V16.3715H18.9916V21.4216L12.6833 16.651V21.4764H11.4623V16.7297L5.19714 21.4795V16.3715H2.61035V8.19097H5.19003V2.51953ZM10.5418 9.22909H3.83131V15.3334H5.1956V13.4079L10.5418 9.22909ZM6.41804 13.8685V19.1631L11.4623 15.3388V9.92479L6.41804 13.8685ZM12.7184 15.2883V9.91969L17.7641 13.8636V16.3715H17.7706V19.109L12.7184 15.2883ZM18.9916 15.3334H20.3494V9.22909H13.6888L18.9916 13.3646V15.3334ZM17.7627 8.19097V4.90743L13.6223 8.19097H17.7627ZM10.5513 8.19097H6.411V4.90743L10.5513 8.19097Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPp);
export default __webpack_public_path__ + "static/media/pp.c8c2682ab951d55e698a4a6b8fd505c8.svg";
export { ForwardRef as ReactComponent };